<div class="gpd-full-page">
  <!-- The filter chips and "New Contract" button that used to render here have both moved
       down into each routed grid's own toolbar (see contract-overview.component.html /
       contract-deadlines.component.html) — they act on that grid, so they now render next to
       what they actually affect instead of a dedicated row up here. -->

  <div class="router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</div>
